import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Creates a new job posting or publishes an existing draft
 *
 * @param {import('../types/CreateJobPosting.parameters').ICreateJobPostingPayload} payload - Request payload
 *   - If payload.postingId is present: publishes existing draft (returns 204)
 *   - If payload.postingId is absent: creates new posting (returns 201)
 *
 * @returns {Promise<import('../types/CreateJobPosting.api').ICreateJobPostingApiResponse>}
 *   Returns a consistent response structure with { data: { postingId } }
 *   - For 201 Created: postingId is the newly created posting ID from server
 *   - For 204 No Content: postingId is echoed back from the payload
 */
export const createOrPublishJobPosting = async (payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post(
    '/posting-service/admin/postings',
    {
      benefits: payload.benefits,
      benefitsOther: payload.benefitsOther,
      description: payload.jobDescription.raw,
      expectedDays: payload.expectedDays,
      maxRate: parseInt(payload.maxRate, 10) || parseInt(payload.minRate, 10) || 0,
      minRate: parseInt(payload.minRate, 10),
      officeId: payload.officeId,
      officeSpecialty: payload.officeSpecialty,
      payType: payload.payType,
      planId: payload.planId,
      postingId: payload.postingId,
      professionType: payload.professionType,
      recruiterEmail: payload.recruiterEmail || null,
      scheduleType: payload.scheduleType,
      subProfession: payload.subProfession,
      title: payload.jobTitle,
    },
    {
      headers,
    },
  );

  // 201 Created - new posting created, return data with postingId
  if (response.status === 201) {
    return response.data;
  }

  // 204 No Content - existing draft published, return void
  if (response.status === 204) {
    return {
      data: {
        postingId: payload.postingId,
      },
    };
  }

  return response.data;
};
